namespace TabAurous.ECommerce {
    export namespace ECommExchangeBOMService {
        export const baseUrl = 'ECommExchange/ECommExchangeBOM';

        export declare function Create(request: Serenity.SaveRequest<ECommExchangeBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ECommExchangeBOMRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ECommExchangeBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ECommExchangeBOMRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "ECommExchange/ECommExchangeBOM/Create",
            Update = "ECommExchange/ECommExchangeBOM/Update",
            Delete = "ECommExchange/ECommExchangeBOM/Delete",
            Retrieve = "ECommExchange/ECommExchangeBOM/Retrieve",
            List = "ECommExchange/ECommExchangeBOM/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ECommExchangeBOMService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
